import { ModalStore, ModalType, ModalProps } from '@/types/stores/modal';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const useModalStore = create<ModalStore>()(
  persist(
    (set, get) => ({
      type: null,
      props: null,

      open: <T extends ModalType>(type: T, props?: ModalProps<T>) => {
        set({ type, props: props ?? null });
      },

      close: () => {
        get().props?.onClose?.();

        set({ type: null, props: null });
      },
    }),
    {
      name: 'modal-store',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useModalStore;
